import { GetLogger, LogLevel, logger, SetDefaultLogger } from "@pandas/logger";
import { servicesOrchestratorValues } from "@/config/services";

const applicationName = "vision-web";

export const GetNewLogger = () =>
	GetLogger(
		servicesOrchestratorValues.environment,
		applicationName,
		servicesOrchestratorValues.credentials.axiom.token,
		servicesOrchestratorValues.credentials.axiom.orgId,
		servicesOrchestratorValues.credentials.axiom.dataset,
		LogLevel.trace,
	);

SetDefaultLogger(GetNewLogger());

export const getLogger = () => logger;

export default logger;
